import { AfterViewInit, Component, inject, input, signal } from '@angular/core';
import { ChildRendererService } from '../../child-renderer.service';
import { Rect } from '@svgdotjs/svg.js';

@Component({
  selector: 'app-highlight-link',
  standalone: true,
  template: `
    <button
      type="button"
      (mouseenter)="onHover()"
      (mouseleave)="onLeave()"
      [class]="
        elClass() + ' ' + (isInSvgAvailable() ? 'text-blue-800' : unavailableClass()) + ' ' + (highlightedComponents.length > 0 ? activeClass() : '')
      ">
      <ng-content></ng-content>
    </button>
  `,
})
export class HighlightLinkComponent implements AfterViewInit {
  componentIdWithinImage = input<string>();
  elClass = input<string>('');
  activeClass = input<string>('');
  unavailableClass = input<string>('');

  isInSvgAvailable = signal<boolean>(false);
  highlightedComponents: Rect[] = [];

  childRenderService = inject(ChildRendererService);

  ngAfterViewInit() {
    this._updateAvailability();
  }

  onHover() {
    const componentId = this.componentIdWithinImage();
    if (componentId) {
      this.highlightedComponents = [];
      this.childRenderService.svgComponents().forEach((svgComp) => {
        const rects = svgComp.highlightSvgComponent(componentId, true);
        this.highlightedComponents.push(...rects);
      });
    }
  }

  onLeave() {
    this.childRenderService.svgComponents().forEach((svgComp) => {
      this.highlightedComponents.forEach((rect) => {
        svgComp.clearComponentHighlight(rect);
      });
    });
    this.highlightedComponents = [];
  }

  // check if component is available in any registered SVG
  private _updateAvailability(): void {
    const componentId = this.componentIdWithinImage();
    if (!componentId) {
      this.isInSvgAvailable.set(false);
      return;
    }
    this.childRenderService.svgComponents().forEach((svgComp) => {
      svgComp.renderingComplete.then(() => {
        this.isInSvgAvailable.set(svgComp.hasComponent(componentId));
      });
    });
  }
}
